import { Component, Input } from '@angular/core';
import { NgStyle } from '@angular/common';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    imports: [NgStyle]
})
export class SpinnerComponent {

    @Input() public margin = "0";
    @Input() public size = "40px";
}
